// artifacts-report-cache (report@2): שורת המטמון מעל המסך של דוח — "חושב לפני X", מצב החישוב וכפתור "חשב מחדש".
import { useEffect, useState } from 'react';
import { T } from '../lib/strings.ts';
import { fmtAgoWords } from '../lib/time.ts';
import { Button } from './ui/button.tsx';
import { IconClock, IconHistory } from './brand/icons.tsx';

/** artifacts-report-cache: רק report ≥ 2 נפתח מהמטמון; report@1 / chat / app — כמו היום. */
export const isCacheable = (a: { kind: string; kindVersion?: number | null }) => a.kind === 'report' && (a.kindVersion ?? 0) >= 2;

/**
 * שורת המטמון מעל המסך: "חושב לפני X" (finishedAt, מתעדכן כל דקה; "נכון ל-" — של ה-Screen עצמו), מצב ("מחשב מחדש…" /
 * "אין נתונים חדשים מאז" / "מחושב רק בבקשה") וכפתור "חשב מחדש" שזמין תמיד. גובה קבוע — ההחלפה לא מזיזה את התוכן.
 */
export function CacheBar({ finishedAt, recomputing, busy, note, onRecompute }: { finishedAt: string | null; recomputing: boolean; busy: boolean; note: string | null; onRecompute: () => void }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => setNow(Date.now()), [finishedAt]);
  return (
    <div className="flex min-h-11 flex-wrap items-center gap-x-3 gap-y-1 text-sm" data-testid="cache-bar">
      {finishedAt && (
        <span className="inline-flex items-center gap-1.5 text-muted-foreground" data-testid="computed-ago">
          <IconClock size={15} />
          {T.artifact.computedAgo(fmtAgoWords(finishedAt, now))}
        </span>
      )}
      <span role="status" className="me-auto inline-flex items-center gap-2 font-medium" data-testid="cache-status">
        {recomputing ? (
          <>
            <span aria-hidden="true" className="relative flex size-2.5 shrink-0">
              <span className="absolute inline-flex size-full animate-ping rounded-sm bg-laser opacity-60" />
              <span className="relative inline-flex size-2.5 rounded-circle bg-laser" />
            </span>
            {T.artifact.recomputing}
          </>
        ) : (
          note && <span className="text-muted-foreground">{note}</span>
        )}
      </span>
      <Button variant="outline" size="sm" className="gap-1.5" onClick={onRecompute} disabled={busy || recomputing} data-testid="recompute">
        <IconHistory size={15} />
        {T.artifact.recompute}
      </Button>
    </div>
  );
}
